import React, { useMemo, useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { errorText } from '../../lib/apiErrors';
import { reassignTask } from '../../lib/tasksApi';

export default function TaskAssignment({ activity, teamMembers = [], onSaved, compact = false }) {
    const auth = useAuth() || {};
    const getAuthHeader = auth.getAuthHeader || (() => ({}));
    const [saving, setSaving] = useState(false);
    const [selected, setSelected] = useState(activity?.owner_id || '');
    const labels = useMemo(() => new Map((teamMembers || []).map(m => [m.user_id, m.name || m.email || m.user_id])), [teamMembers]);
    if (!activity || activity.type !== 'task') return null;

    const owner = activity.owner_name || labels.get(activity.owner_id) || 'Unassigned';
    const creator = activity.created_by_name || labels.get(activity.created_by) || 'Unknown';
    const canReassign = Boolean(activity.can_reassign && teamMembers.length);

    const save = async (value) => {
        if (!value || value === activity.owner_id) return;
        setSaving(true);
        try {
            const next = await reassignTask(activity.activity_id || activity.id, {
                owner_id: value,
                expected_owner_id: activity.owner_id ?? null,
            }, getAuthHeader());
            toast.success('Task reassigned');
            onSaved?.(next);
        } catch (err) {
            toast.error(errorText(err, 'Failed to reassign task'));
            setSelected(activity.owner_id || '');
        } finally { setSaving(false); }
    };

    return (
        <div className={`flex items-center gap-2 text-[11px] text-stone-500 ${compact ? '' : 'mt-2'}`} data-testid="task-assignment">
            <span>Assigned to <span className="font-medium text-stone-700">{owner}</span> · created by <span className="font-medium text-stone-700">{creator}</span></span>
            {canReassign && (
                <select aria-label="Reassign task" value={selected} disabled={saving}
                    onChange={e => { setSelected(e.target.value); save(e.target.value); }}
                    className="text-[11px] border border-stone-200 rounded px-1 py-0.5 bg-white">
                    <option value="">Reassign…</option>
                    {teamMembers.map(member => <option key={member.user_id} value={member.user_id}>{member.name || member.email}</option>)}
                </select>
            )}
        </div>
    );
}
